var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar"},[_c('div',{staticClass:"title-bar-left"},[(_vm.icon)?_c('iconic',{staticClass:"title-bar-icon",attrs:{"name":_vm.icon}}):_vm._e(),_c('span',{staticClass:"title-bar-text"},[_vm._v(_vm._s(_vm.title))])],1),_c('div',{staticClass:"title-bar-right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }